import React, { useState, useRef, useEffect } from "react";
// import config from "../../assets/config.json";
import styles from "./DefineMyCommunity.module.scss";
import {
  CalciteBlock,
  CalciteIcon,
  CalciteLabel,
  CalciteButton,
  CalciteSlider,
} from "@esri/calcite-components-react";
import ClearResultsButton from "./ClearResultsButton/ClearResultsButton";
import config from '../../assets/config.json'
import Search from "@arcgis/core/widgets/Search";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import Geometry from "@arcgis/core/geometry/Geometry";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
// import LocatorSearchSource from "@arcgis/core/widgets/Search/LocatorSearchSource";


let activeSearchSource: string = "Address/Coordinate";
let sliderValue: number = 0.5;
const DefineMyCommunity = (props) => {
  // const [sliderValue, setSliderValue] = useState<number>(1);
  const [lastSelectedResult, setLastSelectedResult] = useState<any>(null);
  const [shouldShowSlider, setShouldShowSlider] = useState<boolean>(true);
  const ourSlider = useRef(null);
  const searchWidgetDiv = useRef(null);
  // const [brownfieldLayer] = useState<any>(props.webmap.layers.find(layer => layer.title === 'Brownfield Grant Jurisdictions'));
  const [brownfieldLayer] = useState<any>(props.webmap.layers.find(
    (e) => e.allLayers && e.allLayers.items.find(
      (p: any) => p.title === config.layerNames.brownfieldLayer.title
      )
    )
    .allLayers.items.find(
      (p: any) => p.title === config.layerNames.brownfieldLayer.title
      )
    );
  // const [sitesLayer] = useState<any>(props.webmap.layers.find(layer => layer.title === 'Sites'));
  const [sitesLayer] = useState<any>(props.webmap.layers.items.find(
    (e) => e.allLayers && e.allLayers.items.find(
      (p: any) => p.title === config.layerNames.sitesLayer.title
      )
  )
  .allLayers.items.find(
    (p: any) => p.title === config.layerNames.sitesLayer.title
    )
  );

    const [searchWidget] = useState<Search>(
      new Search({
        view: props.view,
        sources: props.sourcesForSearching,
        includeDefaultSources: false,
        searchAllEnabled: false,
        suggestionsEnabled: true,
        resultGraphicEnabled: true,
        activeSourceIndex: 0,
        minSuggestCharacters: 1,
        maxSuggestions: 1000,
      })
    );

    if (!searchWidget.hasEventListener('search-complete')) {
      searchWidget.on("search-complete", async (event) => {
        if (event.results.length >= 1) {
          if (event.results[0].results.length >= 1) {
            const topResult = event.results[0].results[0].feature;
            if (searchWidget.activeSource.name === "Brownfield Grant Info") {
              // do things
              const query = brownfieldLayer.createQuery();
              query.where = `JURISDICTION_ID = ${topResult.attributes.JURISDICTION_ID}`;
              query.returnGeometry = true;
              query.maxAllowableOffset = 500;
              brownfieldLayer
                .queryFeatures(query)
                .then(function (response) {
                  let selectedResult = {
                    feature: { geometry: response.features[0].geometry },
                  };
                  let searchGraphic = drawShape(selectedResult);
                  setLastSelectedResult(selectedResult);
                  props.view.graphics.removeAll();
                  props.view.graphics.add(searchGraphic);
                  props.view.extent = response.features[0].geometry.extent;
                })
                .catch((e) => {
                  console.error("error occured during query, ", e);
                });
              // set searchTerm to agreement number
              searchWidget.searchTerm =
                topResult.attributes.COOPERATIVE_AGREEMENT_PC;
            } else if (searchWidget.activeSource.name === "Cleanup Name") {
              const query = sitesLayer.createQuery();
              query.where = `REGISTRY_ID = '${topResult.attributes.REGISTRY_ID}'`;
              query.returnGeometry = true;
              sitesLayer
                .queryFeatures(query)
                .then(function (response) {
                  if (response.features.length === 0) {
                    alert('No features found for this cleanup name');
                    return;
                  } else {
                    let selectedResult = {
                      feature: { geometry: response.features[0].geometry },
                    };
                    let searchGraphic = drawCircle(selectedResult);
                    setLastSelectedResult(selectedResult);
                    props.view.graphics.removeAll();
                    props.view.graphics.add(searchGraphic);
                    props.view.goTo({
                      center: [
                        response.features[0].geometry.longitude,
                        response.features[0].geometry.latitude,
                      ],
                      zoom: 15,
                    });
                  }
                })
                .catch((e) => {
                  console.error("error occured during query, ", e);
                });
              searchWidget.searchTerm = topResult.attributes.ALTERNATIVE_NAME;
            }
          }
        }
        // toggle layer visibility if it is a point layer that is not on by default
        const activeSource: any = searchWidget.activeSource;
        if (activeSource.layer && activeSource.layer.geometryType === 'point') {
          activeSource.layer.visible = true;
          if (activeSource.layer.parent) {
            activeSource.layer.parent.visible = true;
          }
        }
      });
    }

    if (!searchWidget.hasEventListener('select-result')) {
      searchWidget.on("select-result", () => {
        props.view.graphics.removeAll();
        let selectedResult = searchWidget.selectedResult;
        // set lastSelectedResult to use in the radiusSliderChange function
        setLastSelectedResult(selectedResult);
        let searchGraphic;
        if (
          activeSearchSource !== "Address/Coordinate" &&
          activeSearchSource !== "DOE Legacy Management Site"
        ) {
          searchGraphic = drawShape(selectedResult);
        } else if (
          activeSearchSource === "Address/Coordinate" ||
          activeSearchSource === "DOE Legacy Management Site" ||
          activeSearchSource === "Cleanup Name" ||
          activeSearchSource === "EPA Facility Registry or Program ID"
        ) {
          searchGraphic = drawCircle(selectedResult);
          if (
            searchWidget.activeSource.name ===
            "EPA Facility Registry or Program ID"
          ) {
            searchWidget.searchTerm =
              selectedResult.feature.attributes.PRIMARY_NAME;
          }
        }
        props.view.graphics.add(searchGraphic);
      });
    }

    if (!searchWidget.hasEventListener('search-clear')) {
      searchWidget.on("search-clear", () => {
        setLastSelectedResult(null);
        props.view.graphics.removeAll();
      });
    }

  // called when a non-Address/Coordinate search-result is selected
  // renders the selected-results geometries on the map
  const drawShape = (selectedResult) => {
    let searchGraphic = new Graphic();
    let simplifiedShape = geometryEngine.simplify(
      selectedResult.feature.geometry
    );
    searchGraphic = new Graphic({
      geometry: simplifiedShape as Geometry,
      // geometry: searchWidget.selectedResult.feature.geometry as Geometry,
      symbol: new SimpleFillSymbol({
        color: [173, 173, 173, 0.5],
      }),
    });
    return searchGraphic;
  };

  // called when an Address/Coordinate search-result is selected and when the radius slider changes value,
  // draws a circle on the map with the specified radius from the radius slider
  const drawCircle = (selectedResult, newSliderValue?) => {
    let radiusValueToUse = sliderValue;
    if (newSliderValue) {
      radiusValueToUse = newSliderValue;
    }
    const ptBuff = geometryEngine.geodesicBuffer(
      selectedResult.feature.geometry,
      radiusValueToUse,
      "miles"
    );
    const ptAsAny: any = ptBuff;
    if (ptAsAny.extent) {
      props.view.extent = ptAsAny.extent;
    }
    let searchGraphic = new Graphic({
      geometry: ptBuff as Geometry,
      symbol: new SimpleFillSymbol({
        color: [173, 173, 173, 0.5],
      }),
    });
    return searchGraphic;
  };
  const [signalSourceChange, setSignalSourceChange] = useState<Number>(Math.random());

  const [classToUse, setClassToUse] = useState<string>('littleBox');
  // called every time the searchWidget is clicked
  const searchWidgetClicked = () => {
    // update activeSearchSource to be equal to searchWidget's active source
    if (activeSearchSource !== searchWidget.activeSource.name) {
      setSignalSourceChange(Math.random());
      // setActiveSearchSource(searchWidget.activeSource.name);
      activeSearchSource = searchWidget.activeSource.name;
    }
    if (['Address/Coordinate','Cleanup Name', 'DOE Legacy Management Site', 'EPA Facility Registry or Program ID'].find(s => s === activeSearchSource)) {
      setShouldShowSlider(true);
    } else setShouldShowSlider(false);
    // disable location search if address/coordinate isn't selected, otherwise make it false
    if (searchWidget.activeSource.name === "Address/Coordinate") {
      searchWidget.locationEnabled = true;
    } else {
      searchWidget.locationEnabled = false;
    }

  };

  const checkMenu = () => {
    if (['suggestion', 'source'].find(s => s ===searchWidget.activeMenu)) {
      setClassToUse('bigBox');
    } else {setClassToUse('littleBox');}
  }

  // called whenever the radius slider changes value,
  // updates sliderValue and re-draws the circle ONLY IF one has already been drawn
  const radiusSliderChange = (event) => {
    if (event.target.value === 0) {
      // just remove the circle. it will be re-drawn when radius slider value is greater than 1
      props.view.graphics.removeAll();
    } else {
      // the radius slider value is greater than 0
      // setSliderValue(event.target.value);
      sliderValue = event.target.value;
      let newSliderValue = event.target.value;
      let newCircle;
      // draw the selectedResult if it isn't null, otherwise draw the lastSelectedResult
      if (searchWidget.selectedResult !== null) {
        newCircle = drawCircle(searchWidget.selectedResult, newSliderValue);
      } else if (searchWidget.selectedResult === null && lastSelectedResult) {
        newCircle = drawCircle(lastSelectedResult, newSliderValue);
      }
      // remove previously drawn graphics and add the new circle
      props.view.graphics.removeAll();
      props.view.graphics.add(newCircle);
    }
  };

  // clear graphics off map and clear text from search widget
  const handleClear = () => {
    searchWidget.clear();
    // setLastSelectedResult(null);
    props.view.graphics.removeAll();
  };

  // called when one of the US buttons are clicked, changes map extent to fit either the entire US or lower 48 states
  const jumpToUSExtents = (whereToJump) => {
    let extentClicked = whereToJump.target.outerText;
    if (extentClicked === "Entire US") {
      props.view.extent = {
        xmin: -19127449.89,
        xmax: -9402213.9,
        ymin: 1918603.6,
        ymax: 11546000.19,
        spatialReference: new SpatialReference({ wkid: 102100 }),
      };
    } else if (extentClicked === "Lower 48") {
      props.view.extent = {
        xmin: -14551929.45,
        xmax: -7497708.98,
        ymin: 2253932.55,
        ymax: 7067630.84,
        spatialReference: new SpatialReference({ wkid: 102100 }),
      };
    }
  };

  useEffect(() => {
    if (searchWidgetDiv.current && !searchWidget.container) {
      searchWidget.container = searchWidgetDiv.current;
    }
  });

  useEffect(() => {}, [props.view, props.sourcesForSearching, lastSelectedResult, sitesLayer, brownfieldLayer, shouldShowSlider, signalSourceChange, classToUse]);
  // useEffect(() => {}, [sliderValue, lastSelectedResult, sitesLayer, brownfieldLayer, shouldShowSlider, signalSourceChange]);

  return (
    <div onBlur = {() => {checkMenu();}} className={styles.mainDiv} onClick = {() => {checkMenu();}}>
      <CalciteBlock
        heading="Define Your Community"
        description="Show map data within your community"
        collapsible
        open
      >
        <CalciteIcon scale="m" slot="icon" icon="information"></CalciteIcon>
        <div className={styles.FormCanvas}>
          <div>
            <CalciteBlock
              className={styles.FormGroup}
              heading={"Search by " + activeSearchSource}
            ></CalciteBlock>
            <CalciteLabel className={styles.InputLabel}>
              {" "}
              {/* {"Search by " + activeSearchSource} */}
            </CalciteLabel>

            <div className={styles.searchWidgetDiv} onClick={searchWidgetClicked} ref={searchWidgetDiv}/>

            {classToUse === 'littleBox' && <div className={styles.littleBox}>
              {activeSearchSource === "EPA Info" && (
                <p>Search by Cleanup Name, EPA Registry ID, Program ID</p>
              )}
            </div>}
            {classToUse === 'bigBox' && <div className={styles.epaInfoDiv}>
              {activeSearchSource === "EPA Info" && (
                <p>Search by Cleanup Name, EPA Registry ID, Program ID</p>
              )}
            </div>}

            <div className={styles.sliderStyle}>
              {(shouldShowSlider) && (
                <CalciteLabel className={styles.InputLabel}>
                  {"Change Radius (mi)"}
                </CalciteLabel>
              )}

              {(shouldShowSlider) && (
                <CalciteSlider
                  className={styles.sliderStyle}
                  onCalciteSliderChange={(event) => {
                    radiusSliderChange(event);
                  }}
                  ref={ourSlider}
                  min={0}
                  minValue={0.5}
                  max={15}
                  ticks={5}
                  snap={true}
                  value={sliderValue}
                  labelHandles={true}
                  step={0.5}
                />
              )}
            </div>

            <div className={styles.buttonDiv}>
              <ClearResultsButton handleClick={handleClear} />
              <CalciteButton
                className={styles.buttons}
                onClick={(event) => {
                  jumpToUSExtents(event);
                }}
              >
                {"Entire US"}
              </CalciteButton>
              <CalciteButton
                className={styles.buttons}
                onClick={(event) => {
                  jumpToUSExtents(event);
                }}
              >
                {"Lower 48"}
              </CalciteButton>
            </div>
          </div>
          <p>
            <a href="https://cimc.epa.gov/ords/cimc/f?p=CIMC:LIST" target="_blank" rel="noreferrer">
              List Cleanups and Grants Page
            </a>{" "}
          </p>
        </div>
      </CalciteBlock>
    </div>
  );
};

export default DefineMyCommunity;
